import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue } from 'bootstrap-vue'
import router from "./router.js"
import {store} from "./store.js"
import globalComponents from "./plugins/globalComponents";
import Notifications from 'vue-notification'
import VueFriendlyIframe from 'vue-friendly-iframe';

Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.use(globalComponents)
Vue.use(VueFriendlyIframe);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
